import { useStore } from "vuex";
import ApiService from "./api.service";

const ApplicationService = {
  async initialiseApplication(server: string) {
    console.log(`Setting server to ${server}`);
    const store = useStore();
    ApiService.init(server, store);
  },
};

export default ApplicationService;
